import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGlobalPulse from "./sections/TheGlobalPulse";
import SystemCapabilities from "./sections/SystemCapabilities";
import TheOriginDream from "./sections/TheOriginDream";
import FunffyMoments from "./sections/FunffyMoments";
import InitiateConnection from "./sections/InitiateConnection";
import TheBlueprint from "./sections/TheBlueprint";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGlobalPulse />
      <SystemCapabilities />
      <TheOriginDream />
      <FunffyMoments />
      <InitiateConnection />
      <TheBlueprint />
      <Footer />
    </div>;
}